import React, { useCallback, useEffect, useRef, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import esLocale from '@fullcalendar/core/locales/es';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { poli, qs } from './poliApi';
import DetallePrueba from './DetallePrueba';

/**
 * P-8 Calendario mensual de citas. El servidor decide que se ve: el cliente solo su compania y el
 * poligrafista solo sus citas. El color es el del estado; un clic abre el detalle de la prueba.
 */
const z = (n) => String(n).padStart(2, '0');
const dia = (d) => `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}`;

const PoliCalendario = () => {
    const toast = useRef(null);
    const [cfg, setCfg] = useState(null);
    const [rango, setRango] = useState(null);
    const [compania, setCompania] = useState(null);
    const [eventos, setEventos] = useState([]);
    const [detalle, setDetalle] = useState(null);

    useEffect(() => {
        poli('/config').then(setCfg).catch((e) => toast.current && toast.current.show({ severity: 'error', summary: 'Error', detail: e.message, life: 4000 }));
    }, []);

    const cargar = useCallback(async () => {
        if (!rango) return;
        try {
            const filas = await poli(`/calendario?${qs({ desde: rango.desde, hasta: rango.hasta, companiaId: compania })}`);
            setEventos(filas.map((f) => ({
                id: String(f.prueba_id),
                title: `${f.apellidos} ${f.nombres}${f.compania ? ' · ' + f.compania : ''}`,
                start: f.fecha_asignada,
                backgroundColor: f.estado_color,
                borderColor: f.estado_color,
                extendedProps: f
            })));
        } catch (e) {
            toast.current && toast.current.show({ severity: 'error', summary: 'Error', detail: e.message, life: 4000 });
        }
    }, [rango, compania]);

    useEffect(() => { cargar(); }, [cargar]);

    const alCambiarFechas = (info) => {
        const hasta = new Date(info.end);
        hasta.setDate(hasta.getDate() - 1);
        setRango({ desde: dia(info.start), hasta: dia(hasta) });
    };

    const angosto = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
    const companias = (cfg && cfg.companias) || [];
    const leyenda = cfg && cfg.estados ? cfg.estados.filter((e) => [2, 4, 5, 6, 7, 8, 9].includes(e.estado)) : [];

    return (
        <div className="grid">
            <Toast ref={toast} />
            <div className="col-12 flex align-items-center justify-content-between flex-wrap gap-2">
                <h4 className="m-0">Calendario de pruebas</h4>
                {companias.length > 1 && (
                    <Dropdown value={compania} options={companias} optionLabel="nombre" optionValue="compania_id" showClear
                        placeholder="Todas las companias" onChange={(e) => setCompania(e.value)} style={{ minWidth: '14rem' }} />
                )}
            </div>
            <div className="col-12">
                <div className="card mb-0">
                    <div className="flex flex-wrap gap-3 mb-3" aria-label="Colores por estado">
                        {leyenda.map((e) => (
                            <span key={e.estado} className="flex align-items-center gap-1 text-sm">
                                <span style={{ width: 12, height: 12, borderRadius: 3, background: e.color, display: 'inline-block' }} />{e.nombre}
                            </span>
                        ))}
                    </div>
                    {/* En el telefono la vista Mes deja 41 px por dia y corta las citas: abre en Dia, con la
                        barra partida (titulo y flechas arriba, cambio de vista abajo) */}
                    <div className={angosto ? 'calendario-angosto' : undefined}>
                        {angosto && <style>{'.calendario-angosto .fc .fc-toolbar-title{font-size:1.15rem}.calendario-angosto .fc .fc-toolbar.fc-footer-toolbar{margin-top:.75rem}'}</style>}
                        <FullCalendar
                            plugins={[dayGridPlugin, timeGridPlugin]}
                            initialView={angosto ? 'timeGridDay' : 'dayGridMonth'}
                            locale={esLocale}
                            headerToolbar={angosto ? { left: 'title', right: 'prev,next' } : { left: 'prev,next today', center: 'title', right: 'dayGridMonth,timeGridWeek' }}
                            footerToolbar={angosto ? { center: 'today timeGridDay,timeGridWeek,dayGridMonth' } : undefined}
                            titleFormat={angosto ? { day: 'numeric', month: 'short', year: 'numeric' } : undefined}
                            events={eventos}
                            datesSet={alCambiarFechas}
                            eventClick={(info) => {
                                // si la cita vino de la lista "+N", se cierra la lista para que no tape el detalle
                                const cerrar = document.querySelector('.fc-popover .fc-popover-close');
                                if (cerrar) cerrar.click();
                                setDetalle(Number(info.event.id));
                            }}
                            eventTimeFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
                            dayMaxEvents={angosto ? 2 : 4}
                            eventMaxStack={angosto ? 2 : undefined}
                            slotEventOverlap={!angosto}
                            nextDayThreshold="09:00:00"
                            allDaySlot={false}
                            scrollTime="07:00:00"
                            height={angosto ? 620 : 'auto'}
                        />
                    </div>
                </div>
            </div>
            <DetallePrueba pruebaId={detalle} cfg={cfg} alCerrar={() => setDetalle(null)} alCambiar={() => cargar()} />
        </div>
    );
};

export default PoliCalendario;
